import { render, staticRenderFns } from "./NewTRSRequest.vue?vue&type=template&id=0ee07994"
import script from "./NewTRSRequest.vue?vue&type=script&lang=js"
export * from "./NewTRSRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports